import React from 'react';
import { ChatItem, ChatItemTypes } from '../../ChatItem/types';
import { CalendarItemChatDialog } from '../CalendarItemChatDialog';
import { ChecklistChatDialog } from '../ChecklistChatDialog';
import { MealChatDialog } from '../MealChatDialog';
import { RecipesChatDialog } from '../RecipesChatDialog';
import { TimeChatDialog } from '../TimeChatDialog';
import { WeatherChatDialog } from '../WeatherChatDialog/WeatherChatDialog';
import { ChatItemDialogProps } from './ChatItemDialogProps';

export const ChatItemDialog = (props: ChatItemDialogProps<ChatItem>) => {
  const { chat_item } = props;

  switch (chat_item.type) {
    case ChatItemTypes.CALENDAR_ITEM:
      if (
        chat_item.data.items.length === 1 &&
        chat_item.data.items[0]?.type === 'Meal'
      ) {
        return <MealChatDialog chat_item={chat_item} />;
      } else {
        return <CalendarItemChatDialog chat_item={chat_item} />;
      }
    case ChatItemTypes.CLOCK:
      return <TimeChatDialog chat_item={chat_item} />;
    case ChatItemTypes.WEATHER:
      return <WeatherChatDialog chat_item={chat_item} />;
    case ChatItemTypes.RECIPE_ITEM:
      return <RecipesChatDialog chat_item={chat_item} />;
    case ChatItemTypes.CHECKLIST:
      return <ChecklistChatDialog chat_item={chat_item} />;
    default:
      return null;
  }
};
